/* eslint-disable */

import React from "react";
import moment from "moment";
import DatasetDetailsModal from "./DatasetDetails";
import CFTranslateFunction from "../translations";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { $, interpolate } from "../../shared/utils/legacy";

class DatasetListItem extends React.Component {
  static defaultProps = {
    selectedCropfields: [],
    selectedMeasurements: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded || false,
      details: false,
    };
  }

  handleClick() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  toggleDetails = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({
      showDetails: !this.state.showDetails,
    });
  };

  getDataset() {
    return this.props.dataset || this.props.result._source;
  }

  getDevices() {
    let ds = this.getDataset();
    if (ds.devices) {
      return ds.devices;
    }
    ds.devices = ds.dataset_measurements.reduce(function (memo, m) {
      let device = m.device;
      if (!device) {
        return memo;
      }
      let machine_name = cropr.getDeviceName(device);
      if ($.inArray(machine_name, memo) === -1) {
        memo.push(machine_name);
      }
      return memo;
    }, []);
    return ds.devices;
  }

  getLayers() {
    let ds = this.getDataset();
    if (ds.layers) {
      return ds.layers;
    }
    ds.layers = [];
    ds.data_set_rois.forEach(function (dsr) {
      let cropfield = cropr.cropfields.findWhere({ did: dsr.roi });
      if (cropfield) {
        dsr.cropfield = cropfield;
        ds.layers.push(dsr);
      }
    });
    return ds.layers;
  }

  render() {
    let dataset = this.getDataset();
    return (
      <div className="card-wrapper js-dataDataset p-2" key={dataset.uuid}>
        {this.state.showDetails ? (
          <DatasetDetailsModal
            handleHide={this.toggleDetails}
            dataset={dataset}
            handleReload={this.props.handleReload}
          />
        ) : null}
        <div className="card" style={{ cursor: "pointer" }} onClick={this.handleClick.bind(this)}>
          <div className="card-body">
            <div className="card-content container w-100 p-0">
              <div className="row">
                <div className="col-9">
                  <span className="font-weight-bold">
                    {dataset.data_format !== "n" && !cropr.share_mode && this.props.handleSelect ? (
                      <input
                        type="checkbox"
                        className="mr-1"
                        onClick={(e) => this.props.handleSelect(e, this.props.uuid)}
                      />
                    ) : null}
                    {dataset.name || CFTranslateFunction(dataset.data_type) || dataset.data_type}

                    {moment().diff(moment(dataset.created), "days") === 0 ? (
                      <span className="ml-1 badge badge-info"> {gettext("new")}</span>
                    ) : (
                      ""
                    )}
                  </span>
                  {dataset.data_format !== "n" && !cropr.share_mode ? (
                    <span className="small ml-1">
                      <a href="#" className="show_dataset_details" onClick={this.toggleDetails}>
                        ({gettext("details")})
                      </a>
                    </span>
                  ) : null}
                </div>
                <div className="col-3 small text-right">
                  {moment(dataset.recording_datetime).format("ll")}
                </div>
              </div>
              <div className="row">
                <div className="col-12">{this.getDevices().join(", ")}</div>
              </div>
              <div className="row small">
                <div className="col-10">
                  {/*{moment(dataset.recording_datetime).format("LT")}*/}
                  {/*{dataset.stopped_recording_datetime*/}
                  {/*    ? ` (${moment.duration(moment(dataset.stopped_recording_datetime).diff(moment(dataset.recording_datetime))).humanize()}), `*/}
                  {/*    : ', '}*/}
                  {!cropr.share_mode
                    ? (this.getLayers().length === 1
                        ? this.getLayers()[0].cropfield.get("name")
                        : interpolate(gettext("%s cropfields"), [this.getLayers().length || 0])) +
                      ", " +
                      (dataset.dataset_measurements.length === 1
                        ? gettext("1 measurement")
                        : interpolate(gettext("%s measurements"), [
                            dataset.dataset_measurements.length || 0,
                          ]))
                    : null}
                </div>
                <div className="col-2">
                  {this.state.expanded ? (
                    <i className="fa fa-chevron-up float-right"></i>
                  ) : (
                    <i className="fa fa-chevron-down float-right"></i>
                  )}
                </div>
              </div>
            </div>
            {this.state.expanded ? (
              <LayerList
                dataset={dataset}
                layers={this.getLayers()}
                toggleMeasurementLayer={this.props.toggleMeasurementLayer}
                selectedMeasurementLayers={this.props.selectedMeasurementLayers}
                selectedCropfields={this.props.selectedCropfields}
                selectedMeasurements={this.props.selectedMeasurements}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

class LayerList extends React.Component {
  constructor(props) {
    super(props);
  }

  getMeasurements() {
    let ds = this.props.dataset;
    let measurements = [];
    let orderDatasetMeasurements = function (m1, m2) {
      function getSortKey(m) {
        let name = m.name;
        let prio = m.prio;
        let isobus_type = cropr.isobus_measurement_types[name.toLowerCase().split("__")[0]];
        return (m.device || "Z") + prio + (isobus_type ? isobus_type.name : name);
      }
      const m1SortKey = getSortKey(m1);
      const m2SortKey = getSortKey(m2);
      if (m1SortKey < m2SortKey) {
        return -1;
      }
      if (m1SortKey > m2SortKey) {
        return 1;
      }
      return 0;
    };
    let dataset_measurements = ds.dataset_measurements;
    if (this.props.selectedMeasurements.length > 0) {
      dataset_measurements = dataset_measurements.filter(
        (m) => this.props.selectedMeasurements.indexOf(m.name) > -1
      );
    }
    dataset_measurements.forEach((m) => {
      const normalized_name = m.name.toLowerCase().split("__")[0];
      const machine = cropr.getDevice(m.device);
      if (machine && machine.get("priority_measurements")) {
        if (machine.get("priority_measurements") === "-") {
          m.prio = 0;
        } else {
          m.prio = machine.get("priority_measurements").indexOf(normalized_name) >= 0 ? 1 : 2;
        }
      }
    });
    dataset_measurements.sort(orderDatasetMeasurements).forEach(function (measurement) {
      const name = measurement.name.split("__")[0];
      const isobus =
        cropr.isobus_measurement_types[measurement.code] ||
        cropr.isobus_measurement_types[name] ||
        cropr.isobus_measurement_types[name.toLowerCase()];
      measurement.display_name = isobus ? isobus.name : name;
      if (measurement.unit) {
        measurement.display_name = `${measurement.display_name} (${measurement.unit})`;
      }
      measurement.machine_name = cropr.getDeviceName(measurement.device);
      measurements.push(measurement);
    });
    return measurements;
  }

  render() {
    let measurements = this.getMeasurements();
    let layers = this.props.layers;
    if (this.props.selectedCropfields.length > 0) {
      layers = layers.filter((l) => this.props.selectedCropfields.indexOf(l.roi) > -1);
    }
    let cropfieldLayers = layers.map((layer) => (
      <CropfieldLayer
        key={layer.id}
        layer={layer}
        dataset={this.props.dataset}
        measurements={measurements}
        layers={this.props.layers}
        toggleMeasurementLayer={this.props.toggleMeasurementLayer}
        selectedMeasurementLayers={this.props.selectedMeasurementLayers}
      />
    ));
    let showRaw =
      ["n", "e"].indexOf(this.props.dataset.data_format) < 0 &&
      this.props.selectedCropfields.length === 0;
    return (
      <div>
        {showRaw ? (
          <RawLayer
            key="rawlayer"
            dataset={this.props.dataset}
            measurements={measurements}
            toggleMeasurementLayer={this.props.toggleMeasurementLayer}
            selectedMeasurementLayers={this.props.selectedMeasurementLayers}
          />
        ) : (
          ""
        )}
        {cropfieldLayers}
      </div>
    );
  }
}

class RawLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.dataset.layers.length === 0,
    };
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    return (
      <div
        className="card-list-item pt-1 border-dash"
        onClick={this.handleClick.bind(this)}
        key={"raw" + this.props.dataset.uuid}
      >
        <i className="icn_dataset"></i>
        <span>{gettext("Dataset")}</span>
        {this.state.expanded ? (
          <MeasurementList
            dataset={this.props.dataset}
            measurements={this.props.measurements}
            toggleMeasurementLayer={this.props.toggleMeasurementLayer}
            selectedMeasurementLayers={this.props.selectedMeasurementLayers}
          />
        ) : null}
      </div>
    );
  }
}

class CropfieldLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.layers.length === 1,
    };
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    let layer = this.props.layer,
      ds = this.props.dataset;
    return (
      <div
        className="card-list-item pt-1 border-dash"
        key={layer.roi_id}
        onClick={this.handleClick.bind(this)}
      >
        <span
          className="parcel-image"
          dangerouslySetInnerHTML={{
            __html: layer.cropfield.getImageTag({ size: 24, class: "left" }),
          }}
        />
        <span>{layer.cropfield.get("name")}</span>
        <span className="pl-1 text-secondary small">
          {layer.cropfield.getRelated("crop", "name")}
          {layer.cropfield.get("variety")
            ? ` (${layer.cropfield.getRelated("variety", "name")})`
            : ""}
        </span>
        {this.state.expanded ? (
          <MeasurementList
            dataset={this.props.dataset}
            measurements={this.props.measurements}
            layer={layer}
            toggleMeasurementLayer={this.props.toggleMeasurementLayer}
            selectedMeasurementLayers={this.props.selectedMeasurementLayers}
          />
        ) : null}
      </div>
    );
  }
}

class MeasurementList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      more: false,
    };
  }

  toggleMore(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      more: !this.state.more,
    });
  }

  render() {
    const p1_measurements = this.props.measurements.filter((m) => {
      return m.prio === 1;
    });
    const measurements_prio_1 = p1_measurements.map((m) => (
      <Measurement
        key={m.id}
        dataset={this.props.dataset}
        measurement={m}
        layer={this.props.layer}
        toggleMeasurementLayer={this.props.toggleMeasurementLayer}
        selectedMeasurementLayers={this.props.selectedMeasurementLayers}
        autoLoad={
          p1_measurements.length === 1 || (p1_measurements.length === 2 && m.name === "NDVI")
        }
      />
    ));
    const measurements_prio_2 = this.props.measurements
      .filter((m) => {
        return m.prio === 2;
      })
      .map((m) => (
        <Measurement
          key={m.id}
          dataset={this.props.dataset}
          measurement={m}
          layer={this.props.layer}
          toggleMeasurementLayer={this.props.toggleMeasurementLayer}
          selectedMeasurementLayers={this.props.selectedMeasurementLayers}
        />
      ));
    return (
      <ul className="container w-100 pl-2 mb-0">
        {measurements_prio_1}
        {this.state.more || measurements_prio_1.length === 0 ? measurements_prio_2 : null}
        {measurements_prio_2.length > 0 && measurements_prio_1.length > 0 ? (
          <li key="more" className="p-2 small d-flex" onClick={this.toggleMore.bind(this)}>
            {this.state.more ? (
              <span>
                {interpolate(gettext("Show %s fewer measurements"), [measurements_prio_2.length])}
              </span>
            ) : (
              <span>
                {interpolate(gettext("Show %s more measurements"), [measurements_prio_2.length])}
              </span>
            )}
          </li>
        ) : null}
      </ul>
    );
  }
}

class Measurement extends React.Component {
  componentDidMount() {
    if (this.props.autoLoad) {
      this.handleClick();
    }
  }

  handleClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.props.toggleMeasurementLayer(this.props.dataset, this.props.measurement, this.props.layer);
  }

  render() {
    let m = this.props.measurement,
      l = this.props.layer,
      ds = this.props.dataset;
    let selectedMeasurementLayer = this.props.selectedMeasurementLayers.find(
      (sml) =>
        sml.dsUuid === ds.uuid && sml.measurementId === m.id && sml.layerId === (l ? l.id : "")
    );
    let loading = selectedMeasurementLayer && !selectedMeasurementLayer.data,
      loaded = selectedMeasurementLayer && selectedMeasurementLayer.data;
    return (
      <li
        key={m.id}
        className={
          "row d-flex p-1 border-dash" +
          (loading ? " loading text-info" : "") +
          (loaded ? " active text-success" : "")
        }
        onClick={this.handleClick.bind(this)}
      >
        <div className="col-1">
          {loading ? (
            <i className="icn_loading">
              <div
                className="spinner-border spinner-border-sm text-info loading"
                role="status"
              ></div>
            </i>
          ) : (
            ""
          )}
          {loaded ? <i className="icn_tick"></i> : ""}
        </div>
        <div className="col-10">
          <span>{m.display_name}</span>
          <span className="small text-secondary ml-2">{m.machine_name}</span>
        </div>
      </li>
    );
  }
}

export default DatasetListItem;
